import styled from 'styled-components'

export const SummaryHeader = styled.div`
  margin-bottom: 8px;
  font-weight: 600;
`

export const SummaryButton = styled.div`
  margin-top: 24px;
`
